<template>
  <p class="q-col-lg-12 q-text-muted popular-products__header q-p-0 q-m-0 q-fw-semibold">{{ promotedProductHeader }}</p>
</template>
<script setup lang="ts">
import {defineProps} from "vue";

defineProps(['promotedProductHeader'])
</script>